var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"form-label"},[_vm._v("Dosya")]),_c('file-uploader',{attrs:{"accept":['pdf','doc','docx','xls','xlsx'],"value":_vm.value,"valueParameter":"File"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }